import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { HolidayStructureAssigantionColumns } from "../../tableColumns/table-columns";
import { holidayStructureAssignationJson } from "../../DynamicFormsJson/Transaction/holidayStrctureAssigantion";
import { getHolidayStructureAssignationGetAll } from "../../Slice/year.slice";

class HolidayStructureAssigantionList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { yearList, getHolidayStructureAssignationGetAll } = this.props;
        return (
            <>
                <DynamicMainScreen
                    showEditIcon={false}
                    formPath={holidayStructureAssignationJson.formPath}
                    screenTitle={holidayStructureAssignationJson.screenTitle}
                    fieldMeta={holidayStructureAssignationJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={holidayStructureAssignationJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={holidayStructureAssignationJson.pdfFileName}
                    excelFileName={holidayStructureAssignationJson.excelFileName}
                    showAddButton={holidayStructureAssignationJson.showAddButton}
                    tableColumnsToFilter={holidayStructureAssignationJson.tableColumnsToFilter}
                    tableColumns={HolidayStructureAssigantionColumns}
                    tableData={yearList?.holidayStructureAssignation}
                    getTableData={getHolidayStructureAssignationGetAll}
                    apiBaseURL={holidayStructureAssignationJson.apiBaseURL}
                    baseIdColumn={holidayStructureAssignationJson.baseIdColumn}
                    showDeleteIcon={true}
                    showViewButtonInTable={false}
                    formPathView={holidayStructureAssignationJson.formPathView}
                    isActiveURL={holidayStructureAssignationJson.isActiveURL}

                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    yearList: state.year,
});
const mapDispatchToProps = {
    getHolidayStructureAssignationGetAll,
};
export default connect(mapStateToProps, mapDispatchToProps)(HolidayStructureAssigantionList);
